import type { PolicyMetaData } from "@/core/types";
import { Button2 } from "@/ui2/atoms/Button";
import { Card2 } from "@/ui2/atoms/Card";
import { Heading2 } from "@/ui2/atoms/Heading";
import { Link2 } from "@/ui2/atoms/Link";
import { cn } from "@/lib/helpers/cn";
import { getVersionedConsentHref } from "@/lib/helpers/getVersionedConsentHref";
import { getCurrentPolicyVersion } from "@/lib/helpers/getCurrentPolicyVersion";
import { getAutomationDataAttr } from "@/utils/automationUtils";

type ConsentAcpProps = {
  onSubmit: (response?: boolean) => Promise<void>;
  policyMetadata: PolicyMetaData;
};

export function ConsentToACP({ onSubmit, policyMetadata }: ConsentAcpProps) {
  const version = getCurrentPolicyVersion({ policyMetadata, policy: "ADVANCED_CARE_PROGRAM" });
  const consentHref = getVersionedConsentHref({ policy: "advanced_care_program", version });

  return (
    <Card2 className={cn("tw:p-12 tw:flex-col tw:gap-8 tw:lg:max-w-148 tw:mx-auto")}>
      <Heading2 as="h1" size={4} className="tw:text-center">
        Review Advanced Care Program Consent
      </Heading2>

      <p className="body-md">
        Your insurance may cover additional services to support your care journey. By providing
        consent, you agree to participate in the{" "}
        <Link2 isExternal href={consentHref}>
          Advanced Care Program
        </Link2>
        . Your care team will determine if these services are right for you.
      </p>

      <div className="tw:flex tw:justify-between tw:gap-3">
        <Button2
          size="lg"
          onPress={() => onSubmit(null)}
          variant="text"
          {...getAutomationDataAttr("consent-to-acp-skip-button")}
        >
          Not now
        </Button2>

        <Button2
          className="tw:w-full"
          onPress={() => onSubmit(true)}
          size="lg"
          {...getAutomationDataAttr("consent-to-acp-acknowledge-and-continue-button")}
        >
          Acknowledge & Continue
        </Button2>
      </div>
    </Card2>
  );
}
